import React, { JSX, useState } from "react";
import { useNavigate } from "react-router-dom";

import { useBoards } from "../contexts/BoardContext";
import AppLayout from "../components/layout/AppLayout";
import CreateBoardModal from "../components/boards/CreateBoardModal";
import JoinBoardModal from "../components/boards/JoinBoardModal";
import "./AppPage.css";

export default function AppPage(): JSX.Element {

  const { boards, loading, refreshBoards } = useBoards();
  const navigate = useNavigate();
  const [isCreateModalOpen, setIsCreateModalOpen] = useState(false);
  const [isJoinModalOpen, setIsJoinModalOpen] = useState(false);

  // Note: Data fetching is now handled globally in BoardContext

  return (
    <AppLayout>
      <div className="dashboard-content">
        <header className="dashboard-header">
          <h1 className="dashboard-title">My Boards</h1>
          <div className="dashboard-actions">
            <button className="action-button primary" onClick={() => setIsJoinModalOpen(true)}>
              Join Board
            </button>
            <button className="action-button primary" onClick={() => setIsCreateModalOpen(true)}>
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <line x1="12" y1="5" x2="12" y2="19"></line>
                <line x1="5" y1="12" x2="19" y2="12"></line>
              </svg>
              Create Board
            </button>
          </div>
        </header>

        <div className="boards-grid">
           {loading ? (
             // Blank while loading - boards will animate in
             null
           ) : boards.length === 0 ? (
            <div className="empty-state">
              <div className="empty-state-icon">
                <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <rect x="3" y="3" width="18" height="18" rx="2" ry="2" />
                  <line x1="12" y1="8" x2="12" y2="16" />
                  <line x1="8" y1="12" x2="16" y2="12" />
                </svg>
              </div>
              <h3 style={{ margin: '0 0 8px', fontWeight: 600 }}>No boards yet</h3>
              <p style={{ margin: 0 }}>Create your first gratitude board or join an existing one.</p>
            </div>
          ) : (
            boards.map((board) => (
              <div
                key={board.id}
                className="board-wrapper"
                onClick={() => navigate(`/board/${board.id}`)}
              >
                <div
                  className="board-card"
                >
                  {board.cover_image_url && (
                    <img
                      src={board.cover_image_url}
                      alt={board.name}
                      className="board-cover-img"
                      onLoad={(e) => e.currentTarget.classList.add('loaded')}
                    />
                  )}
                </div>
                <h3 className="board-title-text">{board.name}</h3>
              </div>
            ))
          )}
        </div>
      </div>

      <CreateBoardModal
        open={isCreateModalOpen}
        onClose={(created) => {
          setIsCreateModalOpen(false);
          if (created) refreshBoards();
        }}
      />

      <JoinBoardModal
        open={isJoinModalOpen}
        onClose={(joined) => {
          setIsJoinModalOpen(false);
          if (joined) refreshBoards();
        }}
      />
    </AppLayout>
  );
}
